// String.prototype.dateFormat =function(){
//     let dt = new Date(this);
//     let d = dt.getDate(); 
//     let m = dt.getMonth() + 1;
//     let y = dt.getFullYear();
//     if(m < 10){
//         m = "0" + m;
//     }
//     if(d < 10){
//         d = "0" + d;
//     }
//     return d + "-" + m + "-" + y;
// }

export const dateFormat = function (s, dmy) {
  if (s === null || s === undefined || s === "") { return "";}
  let dt = dmy ? StringToDate(s) : new Date(s);
  let d = dt.getDate();
  let m = dt.getMonth() + 1;
  let y = dt.getFullYear();
  if (m < 10) {
    m = "0" + m;
  }
  if (d < 10) {
    d = "0" + d;
  }
  return d + "-" + m + "-" + y;
}


export const maxDate =function () {
    return new Date().toJSON().split('T')[0];
}
// String.prototype.dateFormatWithTime =function(){
//     let dt = new Date(this);
//     let d = dt.getDate(); 
//     let m = dt.getMonth() + 1;
//     let y = dt.getFullYear();
//     let hr = dt.getHours();
//     let min = dt.getMinutes();
//     if(m < 10){
//         m = "0" + m;
//     }
//     if(d < 10){
//         d = "0" + d;
//     }
//     if(hr < 10){
//         hr = "0" + hr;
//     }
//     if(min < 10){
//         min = "0" + min;
//     }
//     return d + "-" + m + "-" + y + " " + hr + "." + min;
// }

export const dateFormatWithTime = function (s) {
    let dt = new Date(s);
    let d = dt.getDate();
    let m = dt.getMonth() + 1;
    let y = dt.getFullYear();
    let hr = dt.getHours();
    let min = dt.getMinutes();
    if (m < 10) {
        m = "0" + m;
    }
    if (d < 10) {
        d = "0" + d;
    }
    if (hr < 10) {
        hr = "0" + hr;
    }
    if (min < 10) {
        min = "0" + min;
    }
    return d + "-" + m + "-" + y + " " + hr + "." + min;
}


// String.prototype.getNoOfdays = function() {
//     let dt1 = new Date(this);
//     let dt2 = new Date();
//     return Math.floor((new Date(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - new Date(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) ) /(1000 * 60 * 60 * 24));
// }


export const getNoOfdays = function (s) {
    let dt1 = new Date(s);
    let dt2 = new Date();
    return Math.floor((new Date(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - new Date(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
}

export const DateToString = (dt) => {
    try {
        let d = new Date(dt);
        let y = d.getFullYear();
        let m = d.getMonth() + 1;
        if (m < 10) {
            m = "0" + m;
        }
        let d1 = d.getDate();
        if (d1 < 10) {
            d1 = "0" + d1;
        }
        return y + "-" + m + "-" + d1;
    }
    catch (e) {
        return "";
    }
}

export const StringToDate =(str)=>{
    try {
       return new Date(str.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"));
    } catch (error) {
        return ""
    }
}

